import { render, staticRenderFns } from "./BlockEcwidStoreUser.vue?vue&type=template&id=64577994&scoped=true&"
import script from "./BlockEcwidStoreUser.vue?vue&type=script&lang=js&"
export * from "./BlockEcwidStoreUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockEcwidStoreUser.vue?vue&type=style&index=0&id=64577994&lang=scss&scoped=true&"
import style1 from "./BlockEcwidStoreUser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64577994",
  null
  
)

export default component.exports